import axios from "axios";
import {
  cacheAdapterEnhancer
} from 'axios-extensions';

let HTTP, IMG_REQUEST, authToken;
const DEFAULT_URL = "https://app.konfuzio.com";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_URL || `${DEFAULT_URL}/api/v3/`
});

IMG_REQUEST = axios.create({
  baseURL: process.env.VUE_APP_DOCUMENT_IMAGES_URL || `${DEFAULT_URL}`,
  responseType: "blob",
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});

const setAuthToken = (token) => {
  authToken = token;
}

const getInterceptorConfig = (config) => {
  if (authToken) {
    config.headers['Authorization'] = `Token ${authToken}`;
  }
  return config;
}

HTTP.interceptors.request.use(getInterceptorConfig,
  error => {
    return Promise.reject(error);
  }
);

IMG_REQUEST.interceptors.request.use(getInterceptorConfig,
  error => {
    return Promise.reject(error);
  }
);

export default {
  HTTP,
  IMG_REQUEST,
  setAuthToken
};